module.exports = __webpack_public_path__ + "static/img/AppPic.2a8330e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AppPic.jpg
// module id = E3Xf
// module chunks = 101